"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBroaderPlaygroundProperty = exports.broaderPlaygroundPropertyDefinition = void 0;
exports.broaderPlaygroundPropertyDefinition = {
    view: { label: 'Parent' },
    constraints: [
        {
            name: 'stencils',
            argument: ['playground', 'collection'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'broader-playground',
};
const isBroaderPlaygroundProperty = (prop) => {
    return prop.name === exports.broaderPlaygroundPropertyDefinition.name;
};
exports.isBroaderPlaygroundProperty = isBroaderPlaygroundProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJvYWRlci1wbGF5Z3JvdW5kLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvYnJvYWRlci1wbGF5Z3JvdW5kLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsbUNBQW1DLEdBQUc7SUFDakQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRTtJQUN6QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLFlBQVksRUFBRSxZQUFZLENBQUM7U0FDdkM7S0FDRjtJQUNELElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsb0JBQW9CO0NBQ0ssQ0FBQTtBQUkxQixNQUFNLDJCQUEyQixHQUFHLENBQUMsSUFBa0IsRUFBcUMsRUFBRTtJQUNuRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssMkNBQW1DLENBQUMsSUFBSSxDQUFBO0FBQy9ELENBQUMsQ0FBQTtBQUZZLFFBQUEsMkJBQTJCLCtCQUV2QyJ9